import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const PrivateRoute = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, isAdmin, isCliente, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box className="d-flex justify-center align-center min-h-screen">
        <CircularProgress />
      </Box>
    );
  }

  // Verificar autenticación
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Si es cliente, SOLO puede acceder a /catalog-client, /my-orders y /profile
  if (isCliente) {
    const allowedClientRoutes = ['/catalog-client', '/my-orders', '/profile'];
    
    // Si está intentando acceder a una ruta NO permitida
    if (!allowedClientRoutes.includes(location.pathname)) {
      return <Navigate to="/catalog-client" replace />;
    }
    
    // Si está en una ruta permitida, dar acceso
    return children;
  }

  // Para admin y vendedores: verificar requisito de admin
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PrivateRoute;


